















































































































import Vue from 'vue'
import { State, Action, namespace } from 'vuex-class'
import { Component, Watch } from 'vue-property-decorator'
import Main from './components/main.vue'
import Banner from '../home/components/Banner.vue'
import Product from '@/model/product/product'
import QRCode from 'qrcode'
import { ProductModal } from '@/apps/ice/store/modules/product'
import { YKDModal } from 'gum-ui'
import { Course, Child, Outline, MyLearn } from '@/model/course/course'
import { Authority } from '@/apps/ice/model/authority'
import CourseItem from './components/course_item.vue'
import { requestVersionInfo } from '@/apps/ice/api/jsons'
import { parseUTC, compare } from '@/apps/ice/utils/time'
import LocalStorage from '@/apps/ice/utils/storage'

import StudyPlanModal from '@/apps/ice/pages/user/components/studyplan/allmodal.vue'
// import StudyPlanShareModal from '@/apps/ice/pages/user/components/studyplan/sharemodal.vue'
import StudyPlanImageModal from '@/apps/ice/pages/studyplan/ImageModal.vue'

const ModuleProduct = namespace('app-ice/product')
const ModuleUser = namespace('app-ice/user')

@Component({
  components: {
    Banner,
    Main,
    YKDModal,
    CourseItem,
    StudyPlanModal,
    // StudyPlanShareModal,
    StudyPlanImageModal
  }
})
export default class PersonalCenter extends Vue {
  @ModuleProduct.State(state => state.productModal)
  private productModal!: ProductModal
  @ModuleProduct.Action('closeProductModal')
  closeProductModal!: Function
  @ModuleProduct.Getter('totalPrice')
  totalPrice!: Function
  @ModuleProduct.Getter('productName')
  productName!: Function
  @ModuleProduct.Getter('productImg')
  productImg!: Function

  @ModuleProduct.State(state => state.allCourseModal)
  private allCourseModal!: boolean
  @ModuleProduct.Action('closeAllCourseModal')
  closeAllCourseModal!: Function

  @ModuleUser.State(state => state.myLearn)
  myLearn?: MyLearn
  @ModuleUser.Getter('currentCourse')
  currentCourse?: Child
  @ModuleUser.State(state => state.authority)
  private authority?: Authority

  @Watch('productModal.visible')
  initQRCode() {
    var canvas = document.getElementById('canvas')
    QRCode.toCanvas(canvas, 'https://www.youkeda.com/home_m/order', function(
      error
    ) {
      if (error) {
        console.error(error)
      } else {
        console.log('success!')
      }
    })
  }

  versionjson: any = ''
  mounted() {
    this.showVersionModal()
  }

  private versionModalvisible: boolean = false
  private async showVersionModal() {
    const storage = new LocalStorage()
    const version = storage.get('version_info')
    this.versionjson = await requestVersionInfo()
    if (this.versionjson) {
      if (!version || version !== this.versionjson.version) {
        const { gmtModified, duration } = this.versionjson
        const aDay = 24 * 60 * 60 * 1000
        const beforeEnd = compare(
          parseUTC(gmtModified).getTime() + aDay * duration,
          new Date()
        )
        const afterStart = compare(parseUTC(gmtModified).getTime(), new Date())
        if (beforeEnd < 0 && afterStart > 0) {
          this.versionModalvisible = true
          storage.set('version_info', this.versionjson.version)
        }
      }
    }
  }

  private closeVersionModal() {
    this.versionModalvisible = false
  }

  versionType: any = {
    feature: '新增',
    bugfix: '修复',
    optimize: '优化'
  }
}
